export default "__VITE_ASSET__Cz$$FloT__"